"use strict";
/**
 * @author Lernik Mirzoyan.
 * Created on 05/02/2018.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var IndicatorDisaggregationGroupDisaggregation = /** @class */ (function () {
    function IndicatorDisaggregationGroupDisaggregation(id, disaggregationGroupId, disaggregationId, orderNumber, showOnTable, filterId, excludedItems) {
        this.id = id;
        this.disaggregationGroupId = disaggregationGroupId;
        this.disaggregationId = disaggregationId;
        this.orderNumber = orderNumber;
        this.showOnTable = showOnTable;
        this.filterId = filterId;
        this.excludedItems = excludedItems;
    }
    return IndicatorDisaggregationGroupDisaggregation;
}());
exports.IndicatorDisaggregationGroupDisaggregation = IndicatorDisaggregationGroupDisaggregation;
//# sourceMappingURL=indicator-disaggregation-group-disaggregation.model.js.map